var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconBadgeAfisha = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#FF3118",
  rx: 7.2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M18.79 9.015c0-1.432-1.161-2.038-2.465-2.038H5.733l-.001 2.016h8.05c.621 0 1.128.239 1.128.978l.003.375h-7.67c-1.338 0-2.118.992-2.118 2.084v2.416c0 .977.73 2.15 2.118 2.15h11.54zM8.992 13.4c0-.535.289-.993 1.122-.993h4.8v2.416h-4.778c-.94 0-1.144-.587-1.144-.895z",
  clipRule: "evenodd"
})));
export default SvgIconBadgeAfisha;